import * as CSV from "csv-string";

export interface PivotCSVRow {
    label: string;
    unit: string;
    values: {gatheredAt: string; value: number}[];
}

const dayKey = (gatheredAt: string): string => {
    const date = new Date(gatheredAt);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(
        2,
        "0"
    )}`;
};

const dayLabel = (key: string): string => {
    const [year, month, day] = key.split("-");
    return `${day}.${month}.${year}`;
};

export const CSVUtils = {
    guessSeparator(): "," | ";" {
        const decimalSeparator = (0.1).toLocaleString().substring(1, 2);
        return decimalSeparator === "." ? "," : ";";
    },
    generateCSV<T>(arr: T[], rowConvertFn: (obj: T) => string[], headers?: string[]): string {
        const universalBOM = "\uFEFF";
        const sep = this.guessSeparator();
        const header = headers ? CSV.stringify(headers, sep) : "";
        const data = arr.map((obj) => CSV.stringify(rowConvertFn(obj), sep));
        return universalBOM + header + data.join("");
    },
    generatePivotCSV(
        rows: PivotCSVRow[],
        labelHeader: string,
        unitHeader: string,
        valueHeaderFn: (dateLabel: string) => string
    ): string {
        const dayKeys = Array.from(new Set(rows.flatMap((r) => r.values.map((v) => dayKey(v.gatheredAt))))).sort();
        const headers = [labelHeader, unitHeader, ...dayKeys.map((k) => valueHeaderFn(dayLabel(k)))];
        const convert = (row: PivotCSVRow): string[] => {
            const valueByDay = new Map<string, number>();
            row.values.forEach((v) => valueByDay.set(dayKey(v.gatheredAt), v.value));
            return [row.label, row.unit, ...dayKeys.map((k) => (valueByDay.has(k) ? `${valueByDay.get(k)}` : "-"))];
        };
        return this.generateCSV(rows, convert, headers);
    },
};
